import styled from "styled-components";
import { Button } from "reactstrap";

export const Container = styled.div`
  position: relative;
`;

export const Title = styled.h5`
  text-align: left;
  margin-bottom: 25px;
`;

export const SubTitle = styled.p``;

export const Strong = styled.strong``;

export const BtsButton = styled(Button)`
  margin: 25px auto;
  padding: 10px 55px;
  display: block;
  position: relative;
`;
